import css from './Frame.module.css';
import classnames from 'classnames/bind';
import { Suspense, useEffect, useState, useContext, lazy } from 'react';
import { CatalogContext } from './Catalog.context';
import Scaler from './Scaler';
import Navigations from 'Navigation';
import { AnimatePresence } from 'framer-motion';

const cx = classnames.bind(css);

export default function Frame() {
  const { lang, pageNum, pageMap, activePageInfo, pagingSpeed, pagingDirection, autoplayRunning, isResponsiveMode } =
    useContext(CatalogContext);

  const activeClasses = () => {
    const classes = [`ct-page--${pageNum}`, `ct-lang--${lang}`];

    for (const key in activePageInfo) {
      const value = activePageInfo[key];
      const type = typeof value;

      if (!value || (type !== 'string' && type !== 'number')) continue;

      classes.push(`ct-${key}--${value}`);
    }

    classes.push(`ct-pagingDirection--${pagingDirection}`);
    classes.push(`ct-autoplayState--${autoplayRunning ? 'playing' : 'paused'}`);

    return classes.join(' ');
  };

  const [Page, setPage] = useState(null);

  useEffect(() => {
    if (!pageMap[pageNum - 1]) return;
    setPage(() => lazy(() => import(`/src/Pages/${pageMap[pageNum - 1]}`)));
  }, [pageNum]);

  return (
    <div className={`${cx('window', `${isResponsiveMode ? 'responsiveMode' : ''}`, activeClasses())} ct-frame-window`}>
      <Scaler className={`${css.container} ct-frame-container`}>
        <div className={`${css.wrapper} ct-frame-wrapper`}>
          <div className={`${cx('page', 'page--active')} ${classnames('ct-frame-page pg--active')}`}>
            <Suspense>
              <AnimatePresence>{Page && <Page isActive={true} />}</AnimatePresence>
            </Suspense>
          </div>
        </div>
        <Navigations />
      </Scaler>
    </div>
  );
}
